import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';


import SingleSelectDroupdown from './project-components/SingleSelectDroupdown';
import SelectDropDowns from '../DemoTabs/SelectDropDowns';
import SelectSearchDroupDown from '../../components/DemoTabs/SelectSearchDroupDown';
import SingleDateWithoutArrow from '../../components/Date-range-picker/SingleDateWithoutArrow';
import MemberProjectProfile from './project-components/MemberProjectProfile';



import PropTypes from 'prop-types';
import {
    Button,
    IconButton,
    Typography,
    Box,
    Modal,
    TextField,
    Tabs,
    Tab,
    InputLabel,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};



// start Tab Sec 
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: '24px 0 0' }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function splitTabs(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


// End Tab Sec 


const SplitTime = ({ open, onClose, }) => {
    // tabs 
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    // tabs 

    // <check Box 
    const [options, setOptions] = useState({
        billAble: true,
    });
    const toggleOption = (key) => {
        setOptions((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
    // <check Box 
    // Project Seclect Single 
    const [selectedProject, setSelectedProject] = useState(null);
    // Project Seclect Single 


    // start Time Select
    const [selectStartTime, setselectStartTime] = useState('');
    const StartTimeData = [
        { name: '7:30 am' },
        { name: '8:00 am' },
        { name: '8:30 am' },
        { name: '9:00 am' },
        { name: '9:30 am' },
        { name: '10:00 am' },
    ];
    // End Time Select

    // start Second Time Select
    const [selectEndTime, setselectEndTime] = useState('');
    const EndTimeData = [
        { name: '7:30 am' },
        { name: '8:00 am' },
        { name: '8:30 am' },
        { name: '9:00 am' },
        { name: '9:30 am' },
        { name: '10:00 am' },
    ];
    // End Second Time Select


    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1' }}>Split time</Typography>

                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    {/* stat tabs  */}
                    <Box sx={{ width: '100%', padding: '0', backgroundColor: '#fff' }}>
                        <Box sx={{ borderBottom: 'none', gap: '16px', }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="basic tabs example"
                                TabIndicatorProps={{ style: { display: 'none' } }} // ✅ Remove underline indicator
                                sx={{
                                    border: 'none',
                                    minHeight: '36px',
                                    display: 'flex',
                                    gap: '16px', // ✅ Adds spacing between tabs
                                }}
                            >
                                <Tab
                                    label="Reassign time"
                                    {...splitTabs(0)}
                                    sx={{
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        minHeight: '36px', // ✅ Sets fixed height
                                        height: '36px',
                                        color: value === 0 ? '#1570EF' : '#344054',
                                        backgroundColor: value === 0 ? '#E0EDFF' : '#FFFFFF',
                                        border: '1px solid #D9D9D9',
                                        borderColor: value === 0 ? '#E0EDFF' : '#D9D9D9',
                                        borderRadius: '100px',
                                        px: '22px',
                                        py: '6px',
                                        marginRight: '16px',
                                        '&:hover': {
                                            backgroundColor: '#E0EDFF',
                                        },
                                    }}
                                />
                                <Tab
                                    label="Delete time"
                                    {...splitTabs(1)}
                                    sx={{
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        minHeight: '36px',
                                        height: '36px',
                                        color: value === 1 ? '#1570EF' : '#344054',
                                        backgroundColor: value === 1 ? '#E0EDFF' : '#FFFFFF',
                                        border: '1px solid #D9D9D9',
                                        borderColor: value === 1 ? '#E0EDFF' : '#D9D9D9',
                                        borderRadius: '100px',
                                        px: '22px',
                                        py: '6px',
                                        '&:hover': {
                                            backgroundColor: '#E0EDFF',
                                        },
                                    }}
                                />
                            </Tabs>
                        </Box>
                        {/* start Reassign time  */}
                        <CustomTabPanel value={value} index={0} padding={0}>
                            <Box sx={{ margin: '0 auto 24px' }}>
                                <MemberProjectProfile />
                            </Box>
                            <Box sx={{ margin: '24px auto ' }}>
                                <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block' }}>Time Span (IST)*</InputLabel>
                                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '8px' }}>
                                    <Box sx={{ width: '100%' }}><SingleDateWithoutArrow /></Box>
                                    <SelectSearchDroupDown label="10:00pm" options={StartTimeData} selectedValue={selectStartTime} onChange={setselectStartTime} />
                                    <SelectSearchDroupDown label="11:00am" options={EndTimeData} selectedValue={selectEndTime} onChange={setselectEndTime} />

                                </Box>

                            </Box>
                            <ul>
                                <li className="cursor-pointer" style={{ margin: '6px auto' }} onClick={() => toggleOption('billAble')}>
                                    <input type="checkbox" checked={options.billAble} readOnly className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', lineHeight: '2' }}>Billable </span>
                                </li>
                            </ul>
                            <Box sx={{ margin: '24px auto 0' }}>
                                <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block' }}>Projects</InputLabel>
                                <SingleSelectDroupdown
                                    selectedProject={selectedProject}
                                    setSelectedProject={setSelectedProject}
                                />
                            </Box>

                            <Box sx={{ margin: '24px auto 0' }}>
                                <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block' }}>Reason*</InputLabel>
                                <TextField fullWidth multiline rows={3} placeholder="What were you working on ? " variant="outlined"
                                    sx={{
                                        marginTop: '0px', '& .MuiOutlinedInput-root': {
                                            fontSize: '14px', color: '#64748B',
                                            '& fieldset': { borderColor: '#D0D5DD', },
                                        }, '& .MuiInputBase-input': { padding: '0px 0px', },
                                    }} />
                            </Box>

                        </CustomTabPanel>
                        {/* End Reassign time  */}

                        {/* start Delete time */}
                        <CustomTabPanel value={value} index={1}>
                            <Box sx={{ margin: '0 auto 24px' }}>
                                <MemberProjectProfile />
                            </Box>
                            <Box sx={{ margin: '24px auto ' }}>
                                <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block' }}>Time Span (IST)*</InputLabel>
                                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '8px' }}>
                                    <Box sx={{ width: '100%' }}><SingleDateWithoutArrow /></Box>
                                    <SelectSearchDroupDown label="10:00pm" options={StartTimeData} selectedValue={selectStartTime} onChange={setselectStartTime} />
                                    <SelectSearchDroupDown label="11:00am" options={EndTimeData} selectedValue={selectEndTime} onChange={setselectEndTime} />

                                </Box>

                            </Box>
                            <ul>
                                <li className="cursor-pointer" style={{ margin: '6px auto' }} onClick={() => toggleOption('billAble')}>
                                    <input type="checkbox" checked={options.billAble} readOnly className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', lineHeight: '2' }}>Billable </span>
                                </li>
                            </ul>

                            <Box sx={{ margin: '24px auto 0' }}>
                                <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block' }}>Reason*</InputLabel>
                                <TextField fullWidth multiline rows={3} placeholder="What were you working on ? " variant="outlined"
                                    sx={{
                                        marginTop: '0px', '& .MuiOutlinedInput-root': {
                                            fontSize: '14px', color: '#64748B',
                                            '& fieldset': { borderColor: '#D0D5DD', },
                                        }, '& .MuiInputBase-input': { padding: '0px 0px', },
                                    }} />
                            </Box>

                        </CustomTabPanel>
                        {/* End Delete time */}

                    </Box>
                    {/* End tabs  */}

                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0' }}>
                        Save
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default SplitTime;
